<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div class="status-icon">
    <icon-colored-draft v-if="status === 'draft'" />
    <icon-colored-pending-approval v-if="status === 'pendingApproval'" />
    <icon-colored-running v-if="status === 'active'" />
    <icon-colored-pause v-if="status === 'paused'" />
    <icon-colored-completed v-if="status === 'completed'" />
    <icon-colored-upcoming v-if="status === 'upcoming'" />
    <icon-colored-approved v-if="status === 'approved'" />
    <icon-colored-rejected v-if="status === 'rejected'" />
    <icon-colored-cancelled v-if="status === 'archived'" />
  </div>
</template>

<script type="text/babel">
  import {
    IconColoredApproved,
    IconColoredCancelled,
    IconColoredCompleted,
    IconColoredDraft,
    IconColoredPause,
    IconColoredPendingApproval,
    IconColoredRejected,
    IconColoredRunning,
    IconColoredUpcoming,
  } from '@/common/icons/colored';

  export default {
    components: {
      IconColoredApproved,
      IconColoredCancelled,
      IconColoredCompleted,
      IconColoredDraft,
      IconColoredRejected,
      IconColoredPause,
      IconColoredPendingApproval,
      IconColoredRunning,
      IconColoredUpcoming,
    },
    props: {
      status: {
        type: String,
        default: 'running',
      },
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  div {
    display: inline-block;
    width: 2rem;
    height: 2rem;
  }
</style>
